// Define cache keys used in the application
const CACHE_KEYS = Object.freeze({
    FEATURED_DEALS: 'FEATURED_DEALS',
});

// Define cache expiry times (in seconds) for each cache key
const CACHE_EXPIRY = Object.freeze({
    FEATURED_DEALS: 7200,
});

export { CACHE_KEYS, CACHE_EXPIRY };
